import { getToken} from '@/utils/auth'
import { logins } from '@/api/login'
// import axios from 'axios'
const state = {
    token: getToken(),
    name: '',
    avatar: '',
    roleType: '',
    userId: '',
    makerId:'',
    dutyList: [],
    menuList: [],
    messagenumber:0,
    newMessage:[]
}

const mutations = {
    SET_TOKEN: (state, token) => {
        state.token = token
    },
    SET_NAME: (state, name) => {
        state.name = name
    },
    SET_AVATAR: (state, avatar) => {
        state.avatar = avatar
    },
    SET_ROLE: (state,roleType) => {
        state.roleType = roleType
    },
    set_USERID: (state,userId) => {
        state.userId = userId
    },
    set_MAKERID: (state,makerId) => {
        state.makerId = makerId
    },
    set_DUTYLIST: (state,dutyList) => {
        state.dutyList = dutyList;
    },
    set_MENULIST: (state,menuList) => {
        state.menuList = menuList;
    },
    set_NEWMESSAGENUM: (state,messagenumber) => {
        state.messagenumber = messagenumber;
    },
    set_newMessage:(state,newMessage) => {
        state.newMessage = newMessage;
    },
}

const actions = {
    // user login
    setToken({commit},data){
        commit('SET_TOKEN', data.value)
    },
    setMagessNum({commit},data){
        commit('set_NEWMESSAGENUM', data)
    },
    setNewMessage({commit},data){
        commit('set_newMessage', data)
    },
    logining({commit}, userInfo) {
        console.log(userInfo,'userInfo')
        const {
            userLogin,
            userPass
        } = userInfo
        return new Promise((resolve, reject) => {
            logins({
                userLogin: userLogin.trim(),
                userPass: userPass,
                agreementSelected:userInfo.agreementSelected
            }).then(response => {
                // console.log(response,'-------');
                let res = response.data;
                if(res.code == 200){
                    commit('SET_TOKEN', res.token);
                    commit('SET_ROLE',res.user.leyeRole.roleType);
                    commit('SET_NAME',res.user.userNick);
                    commit('set_USERID',res.user.userId);
                    commit('set_ID',res.user.id);
                    commit('set_MAKERID',res.user.makerId);
                    commit('set_DUTYLIST',res.user.dutyList);
                    commit('set_MENULIST',res.user.menuList);
                    localStorage.setItem('token',res.token);
                    localStorage.setItem('userNick',res.user.userNick);
                    localStorage.setItem('userImage',res.user.userImage);
                    localStorage.setItem('userPhone',res.user.userPhone);
                    localStorage.setItem('passInit',res.user.passInit);
                    localStorage.setItem('job',res.user.job);
                    localStorage.setItem('roleType',res.user.leyeRole.roleType);
                    localStorage.setItem('userId',res.user.userId);
                    localStorage.setItem('id',res.user.id);
                    localStorage.setItem('makerId',res.user.makerId);
                    localStorage.setItem('userRoleId',res.user.userRoleId);
                    localStorage.setItem('dutyList',JSON.stringify(res.user.dutyList));
                    localStorage.setItem('menuList',JSON.stringify(res.user.menuList));
                    // console.log(res);
                    resolve(res)
                }else{
                    reject(res.msg)
                }
                
            }).catch(error => {
                reject(error)
            })
        })
    },
}

export default {
    namespaced: true,
    state,
    mutations,
    actions
}